import React, { FC } from 'react';
import moment from 'moment';
import { Avatar, Box, Typography } from '@material-ui/core';
import { Discussions_discussions_discussions_lastMessage } from '../../../graphql/discussion/types/Discussions';
import useStyles from './styles';

interface DiscussionItemProps {
  active?: boolean;
  discussionName?: string;
  discussionAvatarUrl?: string;
  lastMessage: Discussions_discussions_discussions_lastMessage | null;
  unseenMessageNumber: number;
  onPress?: (event: any) => void;
}

const DiscussionItem: FC<DiscussionItemProps> = (props) => {
  const {
    active,
    discussionName,
    discussionAvatarUrl,
    lastMessage,
    unseenMessageNumber,
    onPress,
  } = props;

  const classes = useStyles();

  const isSeen = !!lastMessage?.isSeenByMe;

  const messageContentText =
    lastMessage && lastMessage.content && lastMessage.content.text
      ? lastMessage.content.text
      : 'Commencer une nouvelle discussion';

  return (
    <Box
      boxShadow={1}
      className={[classes.wrapper, active && classes.wrapperActive].join(' ')}
      onClick={(event) => {
        onPress && onPress(event);
      }}>
      <Avatar className={classes.avatar} src={discussionAvatarUrl} />
      <Box className={classes.header}>
        <Typography noWrap className={classes.title}>
          {discussionName}
        </Typography>
        <Typography
          noWrap
          className={[classes.subtitle, !isSeen && classes.bold].join(' ')}>
          {messageContentText}
        </Typography>
      </Box>
      <Box className={classes.adornment}>
        {lastMessage && (
          <Box>
            <Typography
              className={[classes.time, !isSeen && classes.bold].join(' ')}>
              {moment(lastMessage?.createdAt).calendar({
                sameDay: 'hh:mm',
                lastDay: '[Hier]',
                lastWeek: 'Do MMM',
                sameElse: 'Do MMM',
              })}
            </Typography>
          </Box>
        )}
        {unseenMessageNumber > 0 && (
          <Box className={classes.counter}>
            <Typography>
              {unseenMessageNumber > 9 ? '9+' : unseenMessageNumber}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DiscussionItem;
